function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { BasicModal } from '@deephaven/components';
import Log from '@deephaven/log';
import { PromiseUtils } from '@deephaven/utils';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { DEFAULT_ROW_HEIGHT } from "./FileListUtils.js";
import { isDirectory } from "./FileStorage.js";
import "./FileExplorer.css";
import FileListContainer from "./FileListContainer.js";
import FileUtils from "./FileUtils.js";
import FileExistsError from "./FileExistsError.js";
import FileNotFoundError from "./FileNotFoundError.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var log = Log.module('FileExplorer');
/**
 * Component that displays and allows interaction with the file system in the provided FileStorage.
 */
export function FileExplorer(props) {
  var storage = props.storage,
    _props$isMultiSelect = props.isMultiSelect,
    isMultiSelect = _props$isMultiSelect === void 0 ? false : _props$isMultiSelect,
    focusedPath = props.focusedPath,
    _props$onCopy = props.onCopy,
    onCopy = _props$onCopy === void 0 ? () => undefined : _props$onCopy,
    _props$onDelete = props.onDelete,
    onDelete = _props$onDelete === void 0 ? () => undefined : _props$onDelete,
    _props$onRename = props.onRename,
    onRename = _props$onRename === void 0 ? () => undefined : _props$onRename,
    _props$onCreateFile = props.onCreateFile,
    onCreateFile = _props$onCreateFile === void 0 ? () => undefined : _props$onCreateFile,
    _props$onCreateFolder = props.onCreateFolder,
    onCreateFolder = _props$onCreateFolder === void 0 ? () => undefined : _props$onCreateFolder,
    onSelect = props.onSelect,
    onSelectionChange = props.onSelectionChange,
    _props$rowHeight = props.rowHeight,
    rowHeight = _props$rowHeight === void 0 ? DEFAULT_ROW_HEIGHT : _props$rowHeight;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    itemsToDelete = _useState2[0],
    setItemsToDelete = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    table = _useState4[0],
    setTable = _useState4[1];
  useEffect(function initializeTable() {
    var tablePromise;
    function initTable() {
      return _initTable.apply(this, arguments);
    }
    function _initTable() {
      _initTable = _asyncToGenerator(function* () {
        log.debug('initTable');
        tablePromise = PromiseUtils.makeCancelable(storage.getTable(), t => t.close());
        try {
          setTable(yield tablePromise);
        } catch (e) {
          if (!PromiseUtils.isCanceled(e)) {
            log.error('Unable to initialize table', e);
          }
        }
      });
      return _initTable.apply(this, arguments);
    }
    initTable();
    return () => {
      tablePromise.cancel();
    };
  }, [storage]);
  var handleError = useCallback(e => {
    if (!PromiseUtils.isCanceled(e)) {
      log.error(e);
    }
  }, []);
  var handleCreateFile = useCallback(() => {
    log.debug('handleCreateFile');
    onCreateFile();
  }, [onCreateFile]);
  var handleCreateFolder = useCallback(() => {
    log.debug('handleCreateFolder');
    onCreateFolder();
  }, [onCreateFolder]);
  var handleCopyFile = useCallback(file => {
    log.debug('handleCopyFile', file.filename);
    onCopy(file);
  }, [onCopy]);
  var handleDelete = useCallback(files => {
    log.debug('handleDelete, pending confirmation', files);
    setItemsToDelete(files);
  }, []);
  var handleDeleteConfirm = useCallback(() => {
    log.debug('handleDeleteConfirm', itemsToDelete);
    itemsToDelete.forEach(file => storage.deleteFile(isDirectory(file) ? FileUtils.makePath(file.filename) : file.filename));
    onDelete(itemsToDelete);
    setItemsToDelete([]);
  }, [itemsToDelete, onDelete, storage]);
  var handleDeleteCancel = useCallback(() => {
    log.debug('handleDeleteCancel');
    setItemsToDelete([]);
  }, []);
  var handleMove = useCallback((files, path) => {
    var filesToMove = FileUtils.reducePaths(files.map(file => isDirectory(file) ? FileUtils.makePath(file.filename) : file.filename));
    filesToMove.forEach(file => {
      var newFile = FileUtils.isPath(file) ? "".concat(path).concat(FileUtils.getBaseName(file.substring(0, file.length - 1)), "/") : "".concat(path).concat(FileUtils.getBaseName(file));
      storage.moveFile(file, newFile).then(() => {
        // Each moved file triggers a rename so parent knows something has happened
        // We signal each individually if for some reason there's an error moving one of the files
        onRename(file, newFile);
      }).catch(handleError);
    });
  }, [handleError, onRename, storage]);
  var handleRename = useCallback((item, newName) => {
    var name = item.filename;
    var isDir = isDirectory(item);
    if (isDir && !name.endsWith('/')) {
      name = "".concat(name, "/");
    }
    var destination = "".concat(FileUtils.getParent(name)).concat(newName);
    if (isDir && !destination.endsWith('/')) {
      destination = "".concat(destination, "/");
    }
    log.debug2('handleRename', name, destination);
    storage.moveFile(name, destination).catch(handleError);
    onRename(name, destination);
  }, [handleError, onRename, storage]);
  var handleValidateRename = useCallback(/*#__PURE__*/function () {
    var _ref = _asyncToGenerator(function* (renameItem, newName) {
      if (newName === renameItem.basename) {
        // Same name is fine
        return undefined;
      }
      FileUtils.validateName(newName);
      var newValue = "".concat(FileUtils.getPath(renameItem.filename)).concat(newName);
      try {
        var fileInfo = yield storage.info(newValue);
        throw new FileExistsError(fileInfo);
      } catch (e) {
        if (!(e instanceof FileNotFoundError)) {
          throw e;
        }
        // The file does not exist, fine to save at that path
      }
    });
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }(), [storage]);
  var isDeleteConfirmationShown = itemsToDelete.length > 0;
  var deleteConfirmationMessage = useMemo(() => {
    if (itemsToDelete.length === 1) {
      return "Are you sure you want to delete \"".concat(itemsToDelete[0].filename, "\"?");
    }
    return "Are you sure you want to delete the selected files?";
  }, [itemsToDelete]);
  return /*#__PURE__*/_jsxs("div", {
    className: "file-explorer",
    children: [table && /*#__PURE__*/_jsx(FileListContainer, {
      isMultiSelect: isMultiSelect,
      focusedPath: focusedPath,
      showContextMenu: true,
      onCopy: handleCopyFile,
      onCreateFolder: handleCreateFolder,
      onCreateFile: handleCreateFile,
      onMove: handleMove,
      onDelete: handleDelete,
      onRename: handleRename,
      onSelect: onSelect,
      onSelectionChange: onSelectionChange,
      rowHeight: rowHeight,
      table: table,
      validateRename: handleValidateRename
    }), /*#__PURE__*/_jsx(BasicModal, {
      isOpen: isDeleteConfirmationShown,
      headerText: deleteConfirmationMessage,
      bodyText: "You cannot undo this action.",
      onCancel: handleDeleteCancel,
      onConfirm: handleDeleteConfirm,
      confirmButtonText: "Delete"
    })]
  });
}
FileExplorer.displayName = 'FileExplorer';
export default FileExplorer;
//# sourceMappingURL=FileExplorer.js.map